import { ReactNode } from 'react'
export interface TableBodyrops {
  children: ReactNode
}

export interface TableBodyHTMLProps {
  id?: string
}

type CombinedTableBodyProps = TableBodyrops & TableBodyHTMLProps

export const TableBody = ({ children, ...rest }: CombinedTableBodyProps): JSX.Element => {
  return (
    <tbody aria-label="table-body" {...rest}>
      {children}
    </tbody>
  )
}
